import React from "react";
import {Route, Routes, Navigate} from "react-router-dom";
import {ProjectContainer} from "./containers/Project/ProjectContainer";
import {OrganizationContainer} from "./containers/Organization/OrganizationContainer";
import {DashboardContainer} from "./containers/Dashboard/Dashboard";
import {LoginContainer} from "./containers/Login/Login";
import {UserContainer} from "./containers/User/UserContainer";
import auth from "./utils/Auth";
import {ViewReport} from "./containers/Report/ViewReport";
import {DocumentContainer} from "./containers/Document/Document";
import {ViewProject} from "./containers/Project/ViewProject";
import {ViewUser} from "./containers/User/ViewUser";
import {ViewOrganization} from "./containers/Organization/ViewOrganization";
import {ForgotPasswordContainer} from "./containers/Login/ForgotPassword";
import {ResetPasswordContainer} from "./containers/Login/ResetPassword";
import {NewUserContainer} from "./containers/Login/NewUser";
import AccountSettings from "./containers/Account/AccountSettings";
import NotFound from "./components/Errors/NotFound";
import Deliveries from "./containers/Refinitiv/Deliveries";
import Collections from "./containers/Refinitiv/Collections";
import {useCurrentUser} from "./hooks/users";
import {useIsRefinitiv} from "./hooks/refinitiv";
import MainContainer from "./containers/Main/MainContainer";

const GenericOrgWrapper = (props) => {
    const isRefinitiv = useIsRefinitiv()

    if (!isRefinitiv) {
        return props.element;
    }

    return <NotFound/>
}

const Router = ({...props}) => {
    const {isLoading, isSuccess, data: user} = useCurrentUser();
    const isAuthenticated = isSuccess && user !== undefined;

    if (isLoading) {
        return null;
    }

    return (
        <MainContainer>
            <Routes>
                <Route path="*" element={<NotFound/>}/>
                {/* Login / Forgot Password Routes */}
                <Route path="/login" element={isAuthenticated ? <Navigate to="/"/> : <LoginContainer/>}/>
                {/*<Route path="/login/new-user" element={isAuthenticated ? <Navigate to="/"/> : <NewUserContainer/>}/>*/}
                <Route path="/login/forgot-password"
                       element={isAuthenticated ? <Navigate to="/"/> : <ForgotPasswordContainer/>}/>
                <Route path="/login/reset-password"
                       element={isAuthenticated ? <Navigate to="/"/> : <ResetPasswordContainer/>}/>

                {/* Shared Routes*/}
                <Route path="/user" element={isAuthenticated ? <UserContainer/> : <Navigate to="/login"/>}/>
                {/*<Route path={`/user/:userId`} element={isAuthenticated ? <ViewUser/> : <Navigate to="/login}"/>}/>*/}
                <Route path="/static/app" element={isAuthenticated ? <DashboardContainer/> : <Navigate to="/login"/>}/>
                <Route path="/" element={isAuthenticated ? <DashboardContainer/> : <Navigate to="/login"/>}/>
                <Route path="/account" element={isAuthenticated ? <AccountSettings/> : <Navigate to="/login"/>}/>

                {/* Generic Org Routes*/}
                <Route path="/project" element={isAuthenticated ? <GenericOrgWrapper element={<ProjectContainer/>}/> :
                    <Navigate to="/login"/>}/>
                {/*<Route path={`/project/:projectId`}*/}
                {/*       element={isAuthenticated ? <GenericOrgWrapper element={<ViewProject/>}/> : <Navigate to="/login"/>}/>*/}
                {/*<Route path={'/project/:projectId/report/:reportId'}*/}
                {/*       element={isAuthenticated ? <GenericOrgWrapper element={<ViewReport/>}/> : <Navigate to="login"/>}/>*/}
                {/*<Route path="/document" element={isAuthenticated ? <GenericOrgWrapper element={<DocumentContainer/>}/> :*/}
                {/*    <Navigate to="/login"/>}/>*/}
                <Route path="/organization"
                       element={isAuthenticated ? <GenericOrgWrapper element={<OrganizationContainer/>}/> :
                           <Navigate to="/login"/>}/>
                {/*<Route path={`/organization/:orgId`}*/}
                {/*       element={isAuthenticated ? <GenericOrgWrapper element={<ViewOrganization/>}/> :*/}
                {/*           <Navigate to="/login"/>}/>*/}

                {/* Refinitiv Routes */}
                <Route path="/deliveries"
                       element={(isAuthenticated) ? <Deliveries mode="allDeliveries"/> : <Navigate to="/login"/>}/>
                <Route path="/recent"
                       element={(isAuthenticated) ? <Deliveries mode="recentDeliveries"/> : <Navigate to="/login"/>}/>
                <Route path="/status" element={(isAuthenticated) ? <Collections/> : <Navigate to="/login"/>}/>
            </Routes>
        </MainContainer>
    )
}

export default Router;